import React, { useState, useMemo } from 'react';
import Select from 'react-select';
import { KTSVG } from '../../../../../rbts/helpers';
import { styleSelect, themeSelect } from '../../../../../rbts/assets/ts/_utils';
import { CreateModal } from '../_modals/CreateModal';
import { RemoveModal } from '../_modals/RemoveModal';
import { ListGrid } from './ListGrid';
import { useObtenerProductos } from '../hooks/ProductosHook';
import { TIPOS_FILTRO_PRODUCTO, TIPOS_EDITABLES } from '../models/ProductoModel';

const View: React.FC = () => {
  const [reloadGrid, setReloadGrid] = useState(Math.random() * 40);
  const [idRow, setIdRow] = useState<number>(0);
  const [tipoFiltro, setTipoFiltro] = useState<string | null>(null);
  const { data, loadingRequest } = useObtenerProductos(reloadGrid);

  const [showCreate, setShowCreate] = useState(false);
  const [showRemove, setShowRemove] = useState(false);

  const dataFiltrada = useMemo(() => {
    if (!tipoFiltro) return data;
    return data.filter((p) => p.tipo === tipoFiltro);
  }, [data, tipoFiltro]);

  const handleNew = () => {
    setIdRow(0);
    setShowCreate(true);
  };

  const handleEdit = (id: number) => {
    setIdRow(id);
    setShowCreate(true);
  };

  const handleDelete = (id: number) => {
    setIdRow(id);
    setShowRemove(true);
  };

  const handleCloseCreate = (updated: boolean) => {
    if (updated) setReloadGrid(Math.random() * 40);
    setShowCreate(false);
    setIdRow(0);
  };

  const handleCloseRemove = (updated: boolean) => {
    if (updated) setReloadGrid(Math.random() * 40);
    setShowRemove(false);
    setIdRow(0);
  };

  return (
    <>
      <div className="row gy-5 g-xl-8">
        <div className="col-xl-12">
          <div className="card card-xxl-stretch mb-5 mb-xl-12">
            <div className="card-header border-0 pt-5">
              <div className="card-title align-items-start flex-column">
                <div style={{ minWidth: '220px' }}>
                  <Select
                    options={[{ value: null, label: 'Todos los tipos' }, ...TIPOS_FILTRO_PRODUCTO] as any}
                    value={
                      tipoFiltro
                        ? TIPOS_FILTRO_PRODUCTO.find((t) => t.value === tipoFiltro) ?? null
                        : { value: null, label: 'Todos los tipos' }
                    }
                    onChange={(opt: any) => setTipoFiltro(opt?.value ?? null)}
                    styles={styleSelect}
                    theme={themeSelect}
                    classNamePrefix="tc-select"
                    placeholder="Filtrar por tipo"
                    isSearchable={false}
                  />
                </div>
              </div>
              <div
                className="card-toolbar"
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                data-bs-trigger="hover"
                title="Nuevo producto"
              >
                <div className="btn btn-sm btn-light-primary" onClick={handleNew}>
                  <KTSVG
                    path="/media/icons/duotune/arrows/arr075.svg"
                    className="svg-icon-5 svg-icon-gray-500 me-1"
                  />
                  Nuevo
                </div>
              </div>
            </div>
            <div className="card-body">
              <div className="row gy-5 g-xl-8">
                <div className="col-xl-12">
                  <ListGrid
                    data={dataFiltrada}
                    loadingGrid={loadingRequest}
                    tiposEditables={TIPOS_EDITABLES}
                    onEditRegister={handleEdit}
                    onDeleteRegister={handleDelete}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <CreateModal id_row={idRow} show={showCreate} handleClose={handleCloseCreate} />
      <RemoveModal id_row={idRow} show={showRemove} handleClose={handleCloseRemove} />
    </>
  );
};

export { View };
